import { useCallback, useState } from 'react';

export type UseCompletableWizardResult = {
  currentStep: number;
  stepsState: boolean[];
  onCompleteStep: (stepIndex: number) => void;
  onCompleteCurrentStep: () => void;
  onInvalidateStep: (stepIndex: number) => void;
  onNavigateToStep: (toStepIndex: number, completeCurrent?: boolean) => void;
};

export type UseCompletableWizard = (stepsCount: number, initialStep?: number) => UseCompletableWizardResult;

export const useCompletableWizard: UseCompletableWizard = (stepsCount, initialStep = 0) => {
  const [completed, setCompleted] = useState<boolean[]>(new Array(stepsCount).fill(false));
  const [current, setCurrent] = useState(initialStep);

  const onCompleteStep = useCallback((stepIndex: number) => {
    setCompleted(stepsState => stepsState.map((v, index) => (index === stepIndex ? true : v)));
  }, []);
  const onInvalidateStep = useCallback((stepIndex: number) => {
    setCompleted(stepsState => stepsState.map((v, index) => (index === stepIndex ? false : v)));
  }, []);

  const onCompleteCurrentStep = useCallback(() => onCompleteStep(current), [current, onCompleteStep]);

  const onNavigateToStep = useCallback(
    (toStepIndex: number, completeCurrent?: boolean) => {
      if (completeCurrent) {
        onCompleteCurrentStep();
      }
      setCurrent(toStepIndex);
    },
    [onCompleteCurrentStep],
  );

  return {
    currentStep: current,
    onCompleteStep,
    onCompleteCurrentStep,
    onInvalidateStep,
    onNavigateToStep,
    stepsState: completed,
  };
};
